import { useContext, useEffect, useState } from 'react'
import dayjs from 'dayjs'

import { ReportingContext } from '../contexts/reporting-context'
import useBankHolidays from './useBankHolidays'

const useTotalWorkingDays = (
  startDate: dayjs.Dayjs | undefined,
  endDate: dayjs.Dayjs | undefined
): number => {
  const [bankholidays, setBankHolidays] = useState<string[]>([])

  const { reportBusinessUnit, reportTeam, reportDateRange } = useContext(ReportingContext)
  const bankHolidays = useBankHolidays(reportBusinessUnit?.region)

  useEffect(() => {
    setBankHolidays(bankHolidays)
  }, [reportBusinessUnit])

  if (
    reportBusinessUnit !== undefined &&
    startDate !== undefined &&
    reportDateRange?.endDate &&
    reportTeam !== undefined
  ) {
    let countWorkingDays = 0
    while (startDate.isBefore(endDate)) {
      if (
        !bankholidays.includes(startDate.format('YYYY-MM-DD')) &&
        startDate.toDate().getDay() !== 0 &&
        startDate.toDate().getDay() !== 6
      ) {
        countWorkingDays += 1
      }
      startDate = startDate.add(1, 'day')
    }
    return countWorkingDays
  } else {
    return 0
  }
}

export default useTotalWorkingDays
